import configurationProvider from "@/Core/configurationProvider";
import { ModuleManager } from "@module-system";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "YKB-KPSMockScreen",
  version: "1.0.0",
  register() {
    console.log("KPS module initializing");

    const mockKpsActive = window.CONFIG.YKB_MOCK_KPS_SCREEN_ACTIVE || (window.CONFIG.YKB_MOCK_KPS_SCREEN_ACTIVE = false);

    if (!mockKpsActive) {
      ModuleManager.addRoute({
        path: "/ykb/kps-ecv",
        name: "Ykb KPS Mock Screen",
        props: true,
        component: () => import("./Components/MockKpsPage.vue"),
      });
    }

    const testActive = configurationProvider.getBoolRef("TEST_ACTIVE", false);

    if (testActive.value) {
      ModuleManager.addRoute({
        path: "/ykb/demo",
        name: "Ykb Test With Token",
        props: true,
        component: () => import("./Components/YkbWebWithToken.vue"),
        beforeEnter: (to, from, next) => {
          if (!testActive.value) {
            next(false);
            return;
          }
          next();
        },
      });
    }
  },
};
export default module;
